module.exports = __webpack_public_path__ + "img/2.8f63a621.png";